import { getTeethNos } from "../../../utils/functions";
export default function ViewServiceModal({ viewServiceModalOpen, selectedServiceDetails, setViewServiceModalOpen, isFdi }) {
    return (<>
        {viewServiceModalOpen && (
            <div
                className="modal fade show mt-0"
                style={{
                    backgroundColor: "rgba(81, 81, 81, 0.5)",
                    display: "block",
                }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content ">
                        <div className="modalScroll">
                            <div className="modal-header">
                                <h5 className="modal-title">View Service</h5>
                            </div>
                            <div className="modal-body">
                                <div className="row"></div>
                                <div className="row">
                                    <div className="col-6">
                                        <label className="form-label">Amount</label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.amount}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">Status</label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.billing_status}
                                        />
                                    </div>
                                </div>

                                <div className="row">

                                    <div className=" col-6">
                                        <label className="form-label">
                                            Discount Type
                                        </label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.discount_type}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">
                                            Discount Value
                                        </label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.discount_value}
                                        />
                                    </div>
                                    <div className=" col-12">
                                        <label className="form-label">
                                            Description
                                        </label>
                                        <textarea
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.description}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">
                                            Extra Notes
                                        </label>
                                        <textarea
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.extra_notes}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">
                                            Net Amount
                                        </label>
                                        <input
                                            className="form-control"
                                            value={selectedServiceDetails.net_amount}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">
                                            Service Code
                                        </label>
                                        <input
                                            className="form-control"
                                            value={selectedServiceDetails.serviceCode}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">
                                            Service Name
                                        </label>
                                        <input
                                            className="form-control"
                                            value={selectedServiceDetails.serviceName}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">
                                            Standard Cost
                                        </label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.standardCost}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">Status</label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={selectedServiceDetails.status}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label">
                                            Teeth Number{" "}
                                        </label>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={getTeethNos(selectedServiceDetails.details, isFdi).join(", ")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer justify-content-end">
                                <button
                                    type="button"
                                    className="cancelText"
                                    onClick={() => {
                                        setViewServiceModalOpen(false);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>)
}